import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

export type Data = OopsyData;

const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.EdensPromiseEternity,
  damageWarn: {
    'E12N Judgment Jolt Single': '585F', // Ramuh get out cast
    'E12N Judgment Jolt': '4E30', // Ramuh get out cast
    'E12N Temporary Current Single': '585C', // Levi get under cast
    'E12N Temporary Current': '4E2D', // Levi get under cast
    'E12N Conflag Strike Single': '585D', // Ifrit get sides cast
    'E12N Conflag Strike': '4E2E', // Ifrit get sides cast
    'E12N Ferostorm Single': '585E', // Garuda get intercardinals cast
    'E12N Ferostorm': '4E2F', // Garuda get intercardinals cast
    'E12N Rapturous Reach 1': '5878', // Haircut
    'E12N Rapturous Reach 2': '5877', // Haircut
    'E12N Bomb Explosion': '586D', // Small bomb explosion
    'E12N Titanic Bomb Explosion': '586F', // Large bomb explosion
  },
  shareWarn: {
    'E12N Earthshaker': '5885', // Earthshaker on first platform
    'E12N Promise Frigid Stone 1': '5867', // Shiva spread with sliding
    'E12N Promise Frigid Stone 2': '5869', // Shiva spread with Rapturous Reach
  },
};

export default triggerSet;
